import React, { useState } from "react";
import Modal from "../ui/Modal";
import RemovableChip from "../ui/RemovableChip";

const VISIBLE_LIMIT = 3;
const GROUP_LABEL = "Sprints apuradas";

function SprintChips({ sprints, onRemove }) {
  const [showingAll, setShowingAll] = useState(false);

  const visible = sprints.slice(0, VISIBLE_LIMIT);
  const hidden = sprints.length - visible.length;

  const chipFor = (sprint) => (
    <RemovableChip
      key={sprint.id}
      label={sprint.name}
      onRemove={() => onRemove(String(sprint.id))}
    />
  );

  return (
    <div className="chips" role="group" aria-label={GROUP_LABEL}>
      {visible.map(chipFor)}

      {hidden > 0 && (
        <button
          className="chip-more"
          type="button"
          aria-label={`Ver todas as ${sprints.length} sprints apuradas`}
          onClick={() => setShowingAll(true)}
        >
          +{hidden}
        </button>
      )}

      {showingAll && (
        <Modal title={GROUP_LABEL} onClose={() => setShowingAll(false)}>
          <div className="chips chips-wrap">{sprints.map(chipFor)}</div>
        </Modal>
      )}
    </div>
  );
}

export default SprintChips;
